var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnfidoLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "123px",
    height: "29px",
    viewBox: "0 0 123 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 34") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.0640252283 6.31605296 0.0640252283 6.31605296 15.1890872 0 15.1890872"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0.144563317 0.173631944 6.46059564 0.173631944 6.46059564 15.2985543 0.144563317 15.2985543"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "0.0516352349 0.0729524823 16.1385906 0.0729524823 16.1385906 16.1054277 0.0516352349 16.1054277"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-7",
    points: "0 28.7945319 122.834899 28.7945319 122.834899 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "global/nav/core",
    transform: "translate(-150.000000, -36.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(150.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-34",
    transform: "translate(0.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.6075312,0.000123404255 C84.0690966,0.000123404255 83.6031,0.192428369 83.2223366,0.571896454 C82.8417795,0.951158865 82.6488181,1.41557021 82.6488181,1.95217305 C82.6488181,2.48918723 82.8417795,2.95339291 83.2223366,3.33244965 C83.6024809,3.71171206 84.0684775,3.90401702 84.6075312,3.90401702 C85.1459658,3.90401702 85.6119624,3.71171206 85.9925195,3.33244965 C86.3732829,2.95277589 86.5662443,2.48877589 86.5662443,1.95217305 C86.5662443,1.41598156 86.3732829,0.951570213 85.9925195,0.57169078 C85.6115497,0.192428369 85.1453466,0.000123404255 84.6075312,0.000123404255",
    id: "Fill-1",
    fill: "#353EF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.91741158,12.0065348 C8.55285453,14.4598113 9.4423344,17.5510879 11.9039854,18.9107972 C14.3656364,20.2709177 17.4674653,19.3844638 18.8320223,16.9309816 C20.1965794,14.4779106 19.3070995,11.3864284 16.8454485,10.0267191 C14.3837975,8.66680426 11.2819686,9.55325816 9.91741158,12.0065348",
    id: "Fill-3",
    fill: "#353EF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.74714262,24.4371482 C7.45326342,24.6129993 7.16867114,24.7989284 6.8931594,24.9928787 C6.70494463,25.125744 6.67563926,25.3943539 6.83269128,25.562595 C7.58740772,26.3694532 8.40486242,27.148134 9.27659396,27.8906163 C10.1776309,28.6579851 11.3929782,28.9615596 12.5499211,28.7052901 C13.7821913,28.432978 14.9771074,28.0909426 16.1193977,27.6835028 C17.8184899,27.0773823 19.4490654,26.3096021 20.9659279,25.4013468 C21.2443289,25.2345454 21.5202534,25.0621908 21.793495,24.8844887 C21.9507534,24.7820631 21.9443557,24.5498574 21.7835889,24.4531908 C17.6094312,21.9441766 12.2164178,21.7607156 7.74714262,24.4371482",
    id: "Fill-5",
    fill: "#353EF4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(0.000000, 0.000206)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(0.000000, 6.787234)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.37227852,1.07649645 C4.19562081,0.783411348 4.0094698,0.499787234 3.81444463,0.225212766 C3.68153859,0.0378439716 3.41180537,0.00863829787 3.24319631,0.164950355 C2.43358389,0.917304965 1.65203859,1.7321844 0.907021812,2.60074468 C0.136827181,3.49851064 -0.167577181,4.7097234 0.0893607383,5.86293617 C0.363015101,7.09101418 0.706011745,8.28186525 1.11484228,9.4202695 C1.7228255,11.1137872 2.49343289,12.7386099 3.40478859,14.2503121 C3.57195302,14.5275603 3.74510235,14.8025461 3.92361745,15.0752695 C4.02618624,15.2317872 4.25918456,15.2254113 4.35618121,15.0651915 C6.87376007,10.9050284 7.05764094,5.53056738 4.37227852,1.07649645",
    id: "Fill-7",
    fill: "#9A9FFA",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.8921072,4.50024468 C21.1859864,4.32418794 21.4707851,4.13867021 21.7462968,3.94451418 C21.9343052,3.81185461 21.9638169,3.54303901 21.8067649,3.37500355 C21.0520485,2.56793972 20.2343874,1.78925887 19.3626559,1.0467766 C18.4618253,0.279202128 17.246478,-0.0241666667 16.0893287,0.231897163 C14.8570586,0.504620567 13.6621424,0.846450355 12.5198522,1.25389007 C10.8207599,1.86001064 9.1901844,2.62779078 7.67352836,3.5360461 C7.39512735,3.70264184 7.11920285,3.87520213 6.84575487,4.05310993 C6.68849648,4.15553546 6.69489413,4.38753546 6.85566091,4.48420213 C11.030025,6.99321631 16.422832,7.17647163 20.8921072,4.50024468",
    id: "Fill-10",
    fill: "#9A9FFA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(22.288591, 6.787234)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.08833775,14.2862227 C2.26499547,14.5791021 2.45114648,14.8627262 2.64617164,15.1373007 C2.77907768,15.3248752 3.04881091,15.3538752 3.21741997,15.1975631 C4.02703238,14.4452085 4.80857768,13.6305348 5.55359446,12.7619745 C6.32378909,11.8640028 6.62819346,10.6527901 6.37125554,9.49978298 C6.09760117,8.27170496 5.75460453,7.0808539 5.34577399,5.94244965 C4.73779077,4.24913759 3.96718339,2.62410922 3.05582768,1.11240709 C2.88866326,0.834953191 2.71551393,0.559967376 2.53699883,0.287449645 C2.43443003,0.130931915 2.20143171,0.137307801 2.10443507,0.29752766 C-0.413143792,4.45748511 -0.597024664,9.83215177 2.08833775,14.2862227",
    id: "Fill-12",
    fill: "#9A9FFA",
    mask: "url(#mask-4)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M62.9411844,6.44912695 C60.6892112,6.44912695 58.9994059,7.35285745 58.0257247,9.06920496 L58.0257247,6.87178652 L55.4462331,6.87178652 L55.4462331,22.0589426 L58.0257247,22.0589426 L58.0257247,14.1635383 C58.0257247,12.5675099 58.4298086,11.2758787 59.2270384,10.3242262 C60.0193153,9.3785383 61.1273471,8.89911277 62.5203841,8.89911277 C63.6938371,8.89911277 64.6347045,9.28310567 65.3167767,10.0403965 C66.0019445,10.8011837 66.3490686,11.9648858 66.3490686,13.4994177 L66.3490686,22.0589426 L68.9285602,22.0589426 L68.9285602,13.0167014 C68.9285602,10.8449922 68.3987935,9.18993546 67.3539126,8.09760213 C66.3368924,7.03468014 64.7698807,6.44912695 62.9411844,6.44912695",
    id: "Fill-16",
    fill: "#353EF4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(106.696309, 6.376092)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5112611,8.08929291 C13.5112611,11.1700801 11.0815983,13.6768319 8.09513356,13.6768319 C5.10887517,13.6768319 2.67921242,11.1700801 2.67921242,8.08929291 C2.67921242,5.00850567 5.10887517,2.50195957 8.09513356,2.50195957 C11.0815983,2.50195957 13.5112611,5.00850567 13.5112611,8.08929291 M8.09513356,0.0729524823 C3.66011678,0.0729524823 0.0516352349,3.66915816 0.0516352349,8.08929291 C0.0516352349,12.5094277 3.66011678,16.1054277 8.09513356,16.1054277 C12.5303567,16.1054277 16.1386319,12.5094277 16.1386319,8.08929291 C16.1386319,3.66915816 12.5303567,0.0729524823 8.09513356,0.0729524823",
    id: "Fill-18",
    fill: "#353EF4",
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50.3627421,14.4653851 C50.3627421,17.5461723 47.9330794,20.0529241 44.9466146,20.0529241 C41.9603562,20.0529241 39.5308998,17.5461723 39.5308998,14.4653851 C39.5308998,11.3845979 41.9603562,8.87805177 44.9466146,8.87805177 C47.9330794,8.87805177 50.3627421,11.3845979 50.3627421,14.4653851 M44.9466146,6.44904468 C40.5115978,6.44904468 36.9033227,10.0452504 36.9033227,14.4653851 C36.9033227,18.8855199 40.5115978,22.4815199 44.9466146,22.4815199 C49.3818378,22.4815199 52.9901129,18.8855199 52.9901129,14.4653851 C52.9901129,10.0452504 49.3818378,6.44904468 44.9466146,6.44904468",
    id: "Fill-21",
    fill: "#353EF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.77472,14.4653851 C101.77472,17.5461723 99.3452633,20.0529241 96.3587985,20.0529241 C93.3723337,20.0529241 90.942671,17.5461723 90.942671,14.4653851 C90.942671,11.3845979 93.3723337,8.87805177 96.3587985,8.87805177 C99.3452633,8.87805177 101.77472,11.3845979 101.77472,14.4653851 Z M101.855825,8.99713688 C100.393033,7.37395957 98.3482616,6.44904468 96.2011273,6.44904468 C91.9343069,6.44904468 88.4632716,10.0452504 88.4632716,14.4653851 C88.4632716,18.8855199 91.9343069,22.4815199 96.2011273,22.4815199 C98.348468,22.4815199 100.39324,21.556605 101.855825,19.933839 L101.855825,22.0588603 L104.435523,22.0588603 L104.435523,0.71465461 L101.855825,0.71465461 L101.855825,8.99713688 Z",
    id: "Fill-23",
    fill: "#353EF4"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-26"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-25",
    fill: "#353EF4",
    mask: "url(#mask-8)",
    points: "83.3176409 22.058922 85.8973389 22.058922 85.8973389 6.87176596 83.3176409 6.87176596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9836834,6.8719305 L75.9836834,3.8684766 C75.9836834,3.12414326 76.5893965,2.52090213 77.3362706,2.52090213 L80.3435794,2.52090213 L80.3435794,0.178278014 L77.0560122,0.178278014 C75.0391012,0.178278014 73.4041918,1.80762553 73.4041918,3.8174695 L73.4041918,6.8719305 L70.5512522,6.8719305 L70.5512522,9.25198723 L73.4035727,9.25198723 L73.4035727,22.0590865 L75.9836834,22.0590865 L75.9836834,9.25198723 L80.3435794,9.25198723 L80.3435794,6.8719305 L75.9836834,6.8719305 Z",
    id: "Fill-27",
    fill: "#353EF4",
    mask: "url(#mask-8)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnfidoLogo);
export default __webpack_public_path__ + "static/media/onfido-logo.1af347527fbbfad550642ce6c998a204.svg";
export { ForwardRef as ReactComponent };